import { render, staticRenderFns } from "./main.vue?vue&type=template&id=40c7d654&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=40c7d654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c7d654",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProfileHeader: require('/home/hitaxi/domains/app.hitaxivipairport.com/front-end/components/ProfileHeader.vue').default})
